import { Controller } from 'stimulus'

// Roles index: one search box finds roles OR the people in them. Matching a
// holder's name filters to their role's card and names them on it, so "which
// role is Maria in?" is answered without leaving this screen.
export default class extends Controller {
  static targets = ['search', 'card', 'empty', 'match']

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visible = 0

    this.cardTargets.forEach((card) => {
      const cardEl = card
      const matches = query === '' || cardEl.dataset.search.includes(query)
      cardEl.hidden = !matches
      if (matches) visible += 1

      const matchLine = cardEl.querySelector('[data-target="roles-index.match"]')
      if (!matchLine) return
      if (query === '' || !matches) {
        matchLine.hidden = true
        matchLine.textContent = ''
        return
      }
      const holders = (cardEl.dataset.holders || '').split('|').filter(Boolean)
      const hits = holders.filter(name => name.toLowerCase().includes(query))
      matchLine.hidden = hits.length === 0
      matchLine.textContent = hits.length > 0 ? `Holder match: ${hits.join(', ')}` : ''
    })

    if (this.hasEmptyTarget) this.emptyTarget.hidden = visible > 0
  }
}
